import type { RouteObject } from "react-router";
import { Documents } from "./Documents";

export const routes = (basePath: string): RouteObject[] => [
  {
    path: basePath,
    children: [
      {
        path: "*",
        element: <Documents />,
      },
    ],
  },
];
